// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__yEWYG","header":"ReportDetails_header__1IUoG","title":"ReportDetails_title__JcPP3","left":"ReportDetails_left__zRwIh"};